const CURSOR_ANIMATION_SPEED = Object.freeze({
  fast: 0.3,
  slow: 0.075
});
function getCursorAnimationSpeed() {
  var _a, _b, _c;
  const value = (_c = (_b = (_a = window.themeCore) == null ? void 0 : _a.objects) == null ? void 0 : _b.settings) == null ? void 0 : _c.custom_cursor_animation_speed;
  const normalizedValue = String(value ?? "").trim().toLowerCase();
  if (normalizedValue === "fast" || normalizedValue === String(CURSOR_ANIMATION_SPEED.fast)) {
    return CURSOR_ANIMATION_SPEED.fast;
  }
  if (normalizedValue === "slow" || normalizedValue === String(CURSOR_ANIMATION_SPEED.slow)) {
    return CURSOR_ANIMATION_SPEED.slow;
  }
  return CURSOR_ANIMATION_SPEED.fast;
}
export {
  getCursorAnimationSpeed as g
};
